export type ErrorMessageProps = Readonly<{
  message?: string | null;
  anchorKey?: string;
  anchorCode?: string;
  className?: string;
}>;

const style = (display: boolean) => ({
  marginBottom: '1rem',
  color: '#aa0000',
  ...(display ? {}: { display: 'none !important' }),
});

const ErrorMessage = (props: ErrorMessageProps) => {
  const anchorKey = props.anchorCode && (
    props.anchorKey === 'id' ? 'id' : `data-${props.anchorKey || 'error'}`
  );

  return <div
    css={style(!!props.message)}
    className={props.className}
    {...(anchorKey ? { [anchorKey]: props.anchorCode } : {})}
  >{props.message}</div>;
};

export default ErrorMessage;
